import { FormFieldResponseDTO, FormFieldTypeDTO } from '@/api/base/DTOs';
import { IFormBase, IFormInput } from '@/forms/typings';
import { InputFormFieldBuilder } from '@/forms/builders';
import { adaptFormFieldResponseToValue } from '../utilities/formFieldResponseToValue.adapter';
import { adaptFormFieldMaskResponseToFormMask } from '../utilities/formFieldMaskResponseToFormMask.adapter';
import { formApiAdapterRegistry } from '../registry/form-api-adapter.registry';

/**
 * Adapts a FormFieldResponseDTO to an InputFormField
 * Handles text, integer, and decimal field types without lookups
 */
export const adaptFormFieldResponseToInputFormField = (
  formFieldResponse: FormFieldResponseDTO,
  parentFieldId?: IFormBase['fieldId'],
): IFormInput => {
  const isNumericType = [
    FormFieldTypeDTO.Integer,
    FormFieldTypeDTO.Decimal,
  ].includes(formFieldResponse.fieldType);

  let inputFormField = new InputFormFieldBuilder()
    .fieldId(formFieldResponse.fieldID)
    .name(formFieldResponse.fieldID)
    .label(formFieldResponse.label ?? formFieldResponse.name)
    .readonly(formFieldResponse.readonly || !formFieldResponse.isEditable)
    .value(adaptFormFieldResponseToValue(formFieldResponse))
    .hasAnyValue(formFieldResponse.hasAnyValue)
    .notApplicable(formFieldResponse.notApplicable)
    .showNotApplicable(formFieldResponse.showNotApplicable)
    .size(formFieldResponse.itemSize)
    .inputType(isNumericType ? 'number' : 'text')
    .mask(adaptFormFieldMaskResponseToFormMask(formFieldResponse.mask))
    .showClearButton(formFieldResponse.showClearButton)
    .suggestedValues(formFieldResponse.suggestedValues);

  if (formFieldResponse.hint) {
    inputFormField = inputFormField.hint(formFieldResponse.hint);
  }

  if (formFieldResponse.hintImageUrl) {
    inputFormField = inputFormField.hintImageUrl(
      formFieldResponse.hintImageUrl,
    );
  }

  const inputFieldValidations =
    formApiAdapterRegistry.adaptGeneric(
      formFieldResponse.restriction,
    ) as IFormInput['validations'];

  if (inputFieldValidations) {
    inputFormField = inputFormField.validations(inputFieldValidations);
  }

  return inputFormField.parentFieldId(parentFieldId).build();
};
